import { useOrganization, useSession } from '@clerk/react';
import { useAuth } from 'src/auth';

export function useChatIdentity(): string {
  const { currentUser } = useAuth();
  const { organization } = useOrganization();
  const { session } = useSession();
  return `${session?.id}:${organization?.id}:${currentUser?.userId}:${currentUser?.organizationId}:${currentUser?.membershipId}`;
}
